<template>

  <div class="centerx">
    <!--
      [Title Card] : 제목이 카드형태로 상단에 노출된다.
      props.title 에 데이터를 넣을 props.enableTitleCard 가 ture(default) 인 경우에 노출

      ex) title="공지사항"
    -->
    <vx-card class="p-6 mb-4" v-if="enableTitleCard && boardTitle && boardTitle.length > 0" >
      <div class="w-full flex" slot="no-body">
        <h5 class="mr-auto flex items-center"><b>{{ boardTitle }}</b></h5>
      </div>
    </vx-card>

    <vx-card>

      <div class="flex flex-wrap items-center justify-between">
        <vs-input class="w-full" v-model="form.title" label="제목"></vs-input>
      </div>

      <div class="flex flex-wrap items-center vx-row mt-5">
        <quill-editor class="vx-col flex-1 ql-edit-text" v-model="form.content" :options="quillOption"></quill-editor>
      </div>

      <!--    파일첨부-->
      <div>
        <vs-upload ref="vs_upload" :action="fileUpLoadAction"
                   :headers="fileUpLoadHeaders" @change="handleChangeFile" @on-success="handleSuccessFileUpload" @on-delete="handleDeleteFile"
                   automatic file-name="file_data" :show-upload-button="false" limit="5"></vs-upload>
      </div>

      <div class="flex flex-wrap items-center justify-center">
        <vs-button class="my-5" @click="handleClickRegister">작성</vs-button>
        <vs-button class="ml-5" @click="handleClickCancel" type="border">취소</vs-button>
      </div>

    </vx-card>
  </div>

</template>

<script>
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import {quillEditor} from 'vue-quill-editor'

export default {
  name: 'TemplateCreateNormal',
  components: {
    quillEditor
  },
  props : {
    // 제목
    boardTitle: String,

    // 상단 제목 카드 노출 여부
    enableTitleCard: { type: Boolean, default: true },

    // 파일 업로드 URL
    fileUpLoadHeaders: Object,
    fileUpLoadAction: String

  },
  data () {
    return {
      quillOption: {
        placeholder: '내용을 입력해주세요 .'
      },

      form: {
        title:'',
        content:''
      }
    }
  },

  created () {
  },

  methods: {
    handleClickRegister () {
      const title = this.form.title
      const content = this.form.content
      this.$emit('handleClickRegister', title, content)
    },
    handleClickCancel () {
      this.$emit('handleClickCancel')
    },
    handleChangeFile (path, files) {
      this.$emit('handleChangeFile', path, files)
    },
    handleSuccessFileUpload (event) {
      // response
      let response = event.currentTarget.response
      response = JSON.parse(response)
      const uploadedFileID = response.id
      this.$emit('handleSuccessFileUpload', uploadedFileID)
    },
    handleDeleteFile (file) {
      this.$emit('handleDeleteFile', file)
    }
  }
}
</script>

<style>
.ql-edit-text .ql-editor {
  overflow-y: scroll;
  resize: vertical;
  min-height: 20em;
}
</style>
